import Vue from 'vue'

const ScannerInstance = Vue.extend(require('./Scanner.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

const getInstance = () => {
  return new ScannerInstance({
    el: document.createElement('div')
  })
}

const close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

const Scanner = (continuous = false) => {
  if (instance) {
    if (continuous) {
      confirmResolve = null
      confirmPromise = null
      confirmPromise = new Promise((resolve) => {
        confirmResolve = resolve
      })

      instance.open(confirmResolve, continuous)
      
      return confirmPromise
    }

    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise((resolve) => {
    confirmResolve = resolve
  })
  instance.open(confirmResolve, continuous)

  return confirmPromise
}

export default Scanner
